export const DEFAULT_DECIMAL_PLACES = 2;

export const round = (number, digits = DEFAULT_DECIMAL_PLACES) =>
  Math.round(number * (10 ** digits)) / (10 ** digits);

// Coerces a raw decimalPlaces value (number, numeric string, or missing) to a valid
// non-negative integer, falling back to the legacy default of 2.
export const resolveDecimalPlaces = (value) => {
  if (value === '' || value === null || value === undefined) return DEFAULT_DECIMAL_PLACES;
  const dp = Number(value);
  return Number.isInteger(dp) && dp >= 0 ? dp : DEFAULT_DECIMAL_PLACES;
};

export const getDecimalPlaces = (material) => resolveDecimalPlaces(material?.decimalPlaces);

export const calculateLine = (quantity = 1, ratio, dp = DEFAULT_DECIMAL_PLACES) => {
  return round(quantity / ratio, dp);
};

export const calculateLegend = (quantity = 1, area, ratio, dp = DEFAULT_DECIMAL_PLACES) => {
  return round(round(quantity * area, dp) / ratio, dp);
};

export const calculateLettering = (
  quantity = 1,
  text = '',
  letterSet,
  ratio,
  dp = DEFAULT_DECIMAL_PLACES,
  throwError = false
) => {
  return text
    .split('')
    .filter((letter) => letter !== ' ')
    .reduce((accum, letter) => {
      if (!letterSet.hasOwnProperty(letter)) {
        if (throwError) throw new Error(`${letter} is not added to the lettering set`);
        return accum;
      }
      return accum + round(round(quantity * letterSet[letter], dp) / ratio, dp);
    }, 0);
};

export const materialCalculations = (material) => {
  const { materialSpecifications } = material || {};
  if (
    !material ||
    !materialSpecifications ||
    material.materialType === 'each' ||
    material.materialType === 'eradication'
  ) {
    return;
  }
  const dp = getDecimalPlaces(material);
  const { line, legend, lettering } = materialSpecifications;

  if (line) {
    if (line.isSF) {
      return round(material.quantity, dp);
    }
    return calculateLine(material.quantity, line.ratio, dp);
  } else if (legend) {
    return calculateLegend(material.quantity, legend.area, legend.ratio, dp);
  } else if (lettering) {
    return calculateLettering(
      material.quantity,
      material.letteringText,
      lettering.letterSet,
      lettering.ratio,
      dp
    );
  }
};

export const eradicationLineAreaToLength = (material) => {
  const dp = getDecimalPlaces(material);
  const convertRatio = material.measurement === 'imperial' ? 12 : 100;
  const widthFactor = round(+material.materialSpecifications.line.width / convertRatio, dp);
  return round(material.quantity / widthFactor, dp);
};

export const eradicationLineLengthToArea = (material) => {
  const dp = getDecimalPlaces(material);
  const convertRatio = material.measurement === 'imperial' ? 12 : 100;
  const widthFactor = round(+material.materialSpecifications.line.width / convertRatio, dp);
  return round(material.quantity * widthFactor, dp);
};
